"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const summithill_models_1 = require("@clearsummit/summithill-models");
const react_1 = __importDefault(require("react"));
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const constants_1 = __importDefault(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProgramCreateForm = ({ program = new summithill_models_1.Program() }) => (react_1.default.createElement(base_form_1.default, { initialValues: program, validationSchema: schemas_1.programCreateSchema, formKey: services_1.endpoints.createProgram, onSubmitPayload: api_payloads_1.createProgramPayload },
    react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_scss_1.default.header },
            react_1.default.createElement("h3", null, constants_1.default.managePrograms.create.newProgram),
            react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
                react_1.default.createElement(buttons_1.SubmitButton, { title: constants_1.default.managePrograms.create.save }))),
        react_1.default.createElement("div", { className: styles_scss_1.default.form },
            react_1.default.createElement(fields_1.TextInputField, { className: styles_scss_1.default.textInputField, name: field_names_1.ProgramCreateFieldNames.name, label: constants_1.default.managePrograms.create.programName, placeholder: constants_1.default.managePrograms.create.programNamePlaceholder, required: true })))));
exports.default = ProgramCreateForm;
